import { render, staticRenderFns } from "./GoodscatsList.vue?vue&type=template&id=368c1c8c&scoped=true&"
import script from "./GoodscatsList.vue?vue&type=script&lang=js&"
export * from "./GoodscatsList.vue?vue&type=script&lang=js&"
import style0 from "./GoodscatsList.vue?vue&type=style&index=0&id=368c1c8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c1c8c",
  null
  
)

export default component.exports